function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultOrgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "80px",
    height: "80px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#d7d7d7",
    d: "M 1.5,-0.5 C 26.8333,-0.5 52.1667,-0.5 77.5,-0.5C 77.8333,0.5 78.5,1.16667 79.5,1.5C 79.5,26.8333 79.5,52.1667 79.5,77.5C 78.5,77.8333 77.8333,78.5 77.5,79.5C 52.1667,79.5 26.8333,79.5 1.5,79.5C 1.16667,78.5 0.5,77.8333 -0.5,77.5C -0.5,52.1667 -0.5,26.8333 -0.5,1.5C 0.5,1.16667 1.16667,0.5 1.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9a9a9a",
    d: "M 13.5,15.5 C 22.5,15.5 31.5,15.5 40.5,15.5C 40.5,19.1667 40.5,22.8333 40.5,26.5C 49.5,26.5 58.5,26.5 67.5,26.5C 67.5,39.1667 67.5,51.8333 67.5,64.5C 49.5,64.5 31.5,64.5 13.5,64.5C 13.5,48.1667 13.5,31.8333 13.5,15.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c4c4c4",
    d: "M 18.5,20.5 C 20.5,20.5 22.5,20.5 24.5,20.5C 24.5,22.5 24.5,24.5 24.5,26.5C 22.5,26.5 20.5,26.5 18.5,26.5C 18.5,24.5 18.5,22.5 18.5,20.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d7d8d7",
    d: "M 19.5,21.5 C 20.8333,21.5 22.1667,21.5 23.5,21.5C 23.5,22.8333 23.5,24.1667 23.5,25.5C 22.1667,25.5 20.8333,25.5 19.5,25.5C 19.5,24.1667 19.5,22.8333 19.5,21.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c2c2c2",
    d: "M 29.5,20.5 C 31.5,20.5 33.5,20.5 35.5,20.5C 35.5,22.5 35.5,24.5 35.5,26.5C 33.5,26.5 31.5,26.5 29.5,26.5C 29.5,24.5 29.5,22.5 29.5,20.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d7d8d7",
    d: "M 30.5,21.5 C 31.8333,21.5 33.1667,21.5 34.5,21.5C 34.5,22.8333 34.5,24.1667 34.5,25.5C 33.1667,25.5 31.8333,25.5 30.5,25.5C 30.5,24.1667 30.5,22.8333 30.5,21.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d4d4d4",
    d: "M 34.5,31.5 C 34.5,33.1667 34.5,34.8333 34.5,36.5C 32.8333,36.5 31.1667,36.5 29.5,36.5C 29.5,34.8333 29.5,33.1667 29.5,31.5C 31.1667,31.5 32.8333,31.5 34.5,31.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d4d4d4",
    d: "M 45.5,53.5 C 46.4614,51.7354 46.7947,49.7354 46.5,47.5C 44.5,47.5 42.5,47.5 40.5,47.5C 40.5,45.8333 40.5,44.1667 40.5,42.5C 42.1667,42.5 43.8333,42.5 45.5,42.5C 45.5,40.8333 45.5,39.1667 45.5,37.5C 43.8333,37.5 42.1667,37.5 40.5,37.5C 40.5,35.5 40.5,33.5 40.5,31.5C 47.8333,31.5 55.1667,31.5 62.5,31.5C 62.5,40.5 62.5,49.5 62.5,58.5C 55.1667,58.5 47.8333,58.5 40.5,58.5C 40.5,56.8333 40.5,55.1667 40.5,53.5C 42.1667,53.5 43.8333,53.5 45.5,53.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c2c2c2",
    d: "M 18.5,31.5 C 20.5,31.5 22.5,31.5 24.5,31.5C 24.5,33.5 24.5,35.5 24.5,37.5C 22.5,37.5 20.5,37.5 18.5,37.5C 18.5,35.5 18.5,33.5 18.5,31.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d7d8d7",
    d: "M 19.5,32.5 C 20.8333,32.5 22.1667,32.5 23.5,32.5C 23.5,33.8333 23.5,35.1667 23.5,36.5C 22.1667,36.5 20.8333,36.5 19.5,36.5C 19.5,35.1667 19.5,33.8333 19.5,32.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bcbcbc",
    d: "M 34.5,31.5 C 35.4614,33.2646 35.7947,35.2646 35.5,37.5C 33.2646,37.7947 31.2646,37.4614 29.5,36.5C 31.1667,36.5 32.8333,36.5 34.5,36.5C 34.5,34.8333 34.5,33.1667 34.5,31.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#999999",
    d: "M 51.5,37.5 C 53.1667,37.5 54.8333,37.5 56.5,37.5C 56.5,39.1667 56.5,40.8333 56.5,42.5C 54.8333,42.5 53.1667,42.5 51.5,42.5C 51.5,40.8333 51.5,39.1667 51.5,37.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d2d2d2",
    d: "M 18.5,42.5 C 20.5,42.5 22.5,42.5 24.5,42.5C 24.5,44.1667 24.5,45.8333 24.5,47.5C 22.5,47.5 20.5,47.5 18.5,47.5C 18.5,45.8333 18.5,44.1667 18.5,42.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d5d5d5",
    d: "M 34.5,42.5 C 34.5,44.1667 34.5,45.8333 34.5,47.5C 32.8333,47.5 31.1667,47.5 29.5,47.5C 29.5,45.8333 29.5,44.1667 29.5,42.5C 31.1667,42.5 32.8333,42.5 34.5,42.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b2b2b2",
    d: "M 34.5,42.5 C 35.4614,44.2646 35.7947,46.2646 35.5,48.5C 33.2646,48.7947 31.2646,48.4614 29.5,47.5C 31.1667,47.5 32.8333,47.5 34.5,47.5C 34.5,45.8333 34.5,44.1667 34.5,42.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bcbcbc",
    d: "M 40.5,47.5 C 42.5,47.5 44.5,47.5 46.5,47.5C 46.7947,49.7354 46.4614,51.7354 45.5,53.5C 45.5,51.8333 45.5,50.1667 45.5,48.5C 43.5853,48.7845 41.9187,48.4511 40.5,47.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9a9a9a",
    d: "M 51.5,48.5 C 53.1667,48.5 54.8333,48.5 56.5,48.5C 56.5,50.1667 56.5,51.8333 56.5,53.5C 54.8333,53.5 53.1667,53.5 51.5,53.5C 51.5,51.8333 51.5,50.1667 51.5,48.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d2d2d2",
    d: "M 18.5,53.5 C 20.5,53.5 22.5,53.5 24.5,53.5C 24.5,55.1667 24.5,56.8333 24.5,58.5C 22.5,58.5 20.5,58.5 18.5,58.5C 18.5,56.8333 18.5,55.1667 18.5,53.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d5d5d5",
    d: "M 29.5,53.5 C 31.1667,53.5 32.8333,53.5 34.5,53.5C 34.5,55.1667 34.5,56.8333 34.5,58.5C 32.8333,58.5 31.1667,58.5 29.5,58.5C 29.5,56.8333 29.5,55.1667 29.5,53.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultOrgAvatar);
export default __webpack_public_path__ + "static/media/default_org_avatar.ebc4231d979b0d31d03e48c0636655e9.svg";
export { ForwardRef as ReactComponent };